module.exports = __webpack_public_path__ + "static/media/ParamLearning.278b0229.svg";